<template>
	<el-dialog
		width="800px"
		:close-on-click-modal="false"
		title="维修确认"
		:visible.sync="dialogFormVisible"
		v-loading="loading"
	>
		<el-form
			:model="form"
			:rules="rules"
			ref="form"
			label-position="right"
			label-width="120px"
			v-loading="loading"
		>
			<el-row :gutter="20">
				<el-col :sm="12" :xs="24">
					<el-form-item label="维修结果:" prop="repairResult">
						<el-select
							v-model="form.repairResult"
							filterable
							clearable
							@change="changeReason"
						>
							<el-option
								v-for="item in resultTypes"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :xs="24">
					<el-form-item
						label="未完成原因:"
						prop="repairIncompleteReason"
						v-if="form.repairResult == 2"
						:rules="[{ required: true, message: '请选择' }]"
					>
						<el-select
							v-model="form.repairIncompleteReason"
							filterable
							clearable
						>
							<el-option
								v-for="item in reasonList"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :xs="24">
					<el-form-item label="维修开始时间:" prop="repairBeginDate">
						<el-date-picker
							style="width: 100%"
							v-model="form.repairBeginDate"
							type="datetime"
							placeholder="选择维修开始时间"
							format="yyyy-MM-dd HH:mm:ss"
							value-format="yyyy-MM-dd HH:mm:ss"
						>
						</el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :xs="24">
					<el-form-item label="维修完成时间:" prop="repairCompleteDate">
						<el-date-picker
							style="width: 100%"
							v-model="form.repairCompleteDate"
							type="datetime"
							placeholder="选择维修完成时间"
							format="yyyy-MM-dd HH:mm:ss"
							value-format="yyyy-MM-dd HH:mm:ss"
						>
						</el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :xs="24">
					<el-form-item label="此次维修金额:" prop="currentRepairAmount">
						<el-input
							v-model="form.currentRepairAmount"
							autocomplete="off"
						></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :xs="24" v-if="isSingleLimit != 0">
					<el-form-item label="剩余维保金额:"> {{ guaLimt }} </el-form-item>
				</el-col>
				<el-col :sm="24" :xs="24">
					<el-form-item required label="维修凭证:" prop="certificateUrls">
						<UploadImgList @change="fileChange"></UploadImgList>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="cancel">取 消</el-button>
			<el-button type="primary" @click="confirm">确 定</el-button>
		</div>
	</el-dialog>
</template>
<script>
import UploadImgList from "@/components/UploadImgList2.vue";
import sDatePicker from "@/components/form/sDatePickerTime";
export default {
	name: "confirmDialog",
	components: {
		UploadImgList,
		sDatePicker,
	},
	data() {
		return {
			loading: false,
			dialogFormVisible: false,
			fkFacilityRepairOrderId: "",
			resultTypes: [
				{ label: "维修完成", value: 1 },
				{ label: "维修未完成", value: 2 },
			],
			reasonList: [
				{ label: "超限额", value: "1" },
				{ label: "市场缺件", value: "2" },
				{ label: "用户原因取消服务", value: "3" },
				{ label: "其他", value: "4" },
			],
			guaLimt: "",
			isSingleLimit: 0,
			form: {
				repairOrderId: "",
				repairResult: "",
				repairIncompleteReason: "",
				repairBeginDate: "",
				repairCompleteDate: "",
				certificateUrls: [],
				currentRepairAmount: "",
			},
			formLabelWidth: "120px",
			rules: {
				repairResult: [
					{
						required: true,
						message: "请选择维修结果",
						trigger: ["blur", "change"],
					},
				],

				currentRepairAmount: [
					{
						required: true,
						message: "请输入维修金额",
						trigger: ["blur", "change"],
					},
				],

				repairBeginDate: [
					{
						required: true,
						message: "请选择维修开始时间",
						trigger: ["blur", "change"],
					},
				],

				repairCompleteDate: [
					{
						required: true,
						message: "请选择维修结束时间",
						trigger: ["blur", "change"],
					},
				],
				certificateUrls: [
					{
						type: "array",
						required: true,
						message: "请上传维修凭证",
						trigger: ["blur", "change"],
					},
				],
			},
		};
	},

	methods: {
		initData(id) {
			console.log(id, 2222);
			this.fkFacilityRepairOrderId = id;
			this.form.repairOrderId = id;
			this.getInfo(id);
		},

		getInfo(id) {
			const vm = this;
			let postData = {
				repairOrderId: id,
			};
			this.$http
				.get(`/facilityRepairOrder/getRepairQuotaInfo`, postData)
				.then(function (response) {
					if (response.data.header.code == "A1000") {
						vm.guaLimt = response.data.body.guaLimt;
						vm.isSingleLimit = response.data.body.isSingleLimit;
					} else {
						vm.$message.warning(response.data.header.msg);
					}
				})
				.catch(function (error) {
					vm.$message.error("网络错误");
				});
		},
		fileChange(files) {
			console.log(files);
			this.form.certificateUrls = files.map((item) => item.name);
		},
		cancel() {
			this.$refs.form.resetFields();
			this.dialogFormVisible = false;
		},
		confirm() {
			const vm = this;
			this.$refs.form.validate((valid) => {
				if (valid) {
					vm.loading = true;
					var postData = {
						...this.form,
					};
					this.$http
						.post("/facilityRepairOrder/confirmRepairOrder", postData)
						.then(function (response) {
							vm.loading = false;
							if (response.data.header.code == "A1000") {
								vm.cancel();
								vm.$message.success(response.data.header.msg);
								vm.$emit("change");
							} else {
								vm.$message.warning(response.data.header.msg);
							}
						})
						.catch(function (error) {
							vm.loading = false;
							// vm.$message.error("网络错误");
						});
				}
			});
		},
	},
};
</script>
